<template>
  <div>
    <group-user />
  </div>
</template>
<script>
import GroupUser from '../components/user-management/user/GroupUser.vue';

export default {
  name: 'ManageGroups',
  components: {
    GroupUser,
  },
};
</script>
<style lang="stylus" scoped></style>
